module.exports = __webpack_public_path__ + "img/route.f6569929.svg";